import Vue from 'vue'
import router from './router'
import App from './App.vue'
import store from "./store/index";


import './plugins/element.js' //  elemnt组件
import './plugins/umyUi.js' //  UmyUi组件
import {post,get,put,deletes,toJson,isEmpty} from './plugins/http.js' // 请求方式中间件
import {api} from './plugins/api.js'  // API 链接
import {open,Base64,formatDate,formatGoods,exportExcelFn} from './plugins/function.js' // 公共方法
import './public/fonts/iconfont.css' // 阿里图标
import './public/style.css' // 公共CSS
import './public/_variables.scss' // 公共变量

import 'babel-polyfill' // 兼容IE


import VueWechatTitle from 'vue-wechat-title' // seo
Vue.use(VueWechatTitle)

//定义全局变量
Vue.prototype.$api=api;
Vue.prototype.$post=post;
Vue.prototype.$get=get;
Vue.prototype.$put=put;
Vue.prototype.$delete=deletes;
Vue.prototype.$toJson=toJson;
Vue.prototype.$isEmpty=isEmpty;
Vue.prototype.$formatGoods=formatGoods;
Vue.prototype.$open=open;
Vue.prototype.$base64 = Base64;
Vue.prototype.$exportExcelFn=exportExcelFn;

// 时间格式化
Vue.filter('formatDate', function (time) {
    var date = new Date(time*1000);
    return formatDate(date, 'yyyy-MM-dd hh:mm');
});

Vue.filter('formatDateAuto', function (time,str) {
    var date = new Date(time*1000);
    return formatDate(date, str);
});

Vue.directive('clickOutside', {
  inserted(el, bindings, vnode) {
      document.addEventListener('click', function(e) {
          if(e.target === el || el.contains(e.target)) {
              return
          } 
          bindings.value()
      })
  },
  unbind() {
      document.removeEventListener('click', function(e) {
          if(e.target === el || el.contains(e.target)) {
              return
          } 
          bindings.value()
      })
  }
})

router.afterEach((to,from,next)=>{
    window,scrollTo(0,0)
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
